module.exports = __webpack_public_path__ + "assets/img/18_1841_big.53b78b08.jpg";